//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable no-unused-expressions */

const defaultLayout = {
    visibility: {
        type: 'enum',
        values: {
            visible: {
                doc: 'The layer is shown.'
            },
            none: {
                'doc': 'The layer is not shown.'
            }
        },
        'default': 'visible',
        'doc': 'Whether this layer is displayed.',
        'sdk-support': {
            'basic functionality': {
                'js': '0.10.0',
                'android': '2.0.1',
                'ios': '2.0.0',
                'macos': '0.1.0'
            }
        }
    }
};
exports.addSource = function (v8, name, source) {
    const sourceKey = getSourceKey(name);
    v8.source.push[sourceKey];
    v8[sourceKey] = source;
};

exports.addLayer = function (v8, name) {
    v8.layer.type.values[name] = {};
    const layoutKey = `layout_${name}`;
    v8[layoutKey] = defaultLayout;
};

exports.addPaint = function (v8, name, paint) {
    const paintKey = getPaintKey(name);
    v8.paint.push(paintKey);
    v8[paintKey] = paint;
};

exports.modifySource = function (v8, name, key, value) {
    const sourceKey = getSourceKey(name);
    v8[sourceKey][key] = value;
};

exports.modifyPaint = function (v8, name, key, value) {
    const paintKey = getPaintKey(name);
    v8[paintKey][key] = value;
};


function getSourceKey(source) {
    return `source_${source}`;
}

function getPaintKey(paint) {
    return `paint_${paint}`;
}
